import * as React from 'react'
import DeckModel from '../models/Deck'

interface IDeckProps {
  model: DeckModel
}

export default class Deck extends React.Component<IDeckProps> {
  deck: DeckModel

  constructor(props: IDeckProps) {
    super(props)
    this.deck = this.props.model
  }

  getStyle() {
    const d = 20
    const m = -this.deck.size * d
    const w = 100
    const h = 100
    const p = 0
    const minDeckSize = this.deck.board.minDeckSize()
    return {
      left: this.deck.location.x * (w + p) + d,
      top: this.deck.location.y * (h + p) + d + (m / d - 1) * d + minDeckSize * 20,
    }
  }

  getCards() {
    const d = 20
    const cards = []
    for (let i = 0; i < this.deck.size; i++) {
      const card = this.deck.cards[i]
      const margin = this.deck.size * d / this.deck.size * i
      const style = {
        transform: `translateY(${margin}px)`,
        zIndex: (this.deck.location.y + 1) * 10
      }

      cards.unshift(<div className='deck-card' key={card.id} style={style}/>)
    }
    return cards
  }

  render() {
    return (
      <div className='deck' style={this.getStyle()}>
        {this.getCards()}
      </div>
    )
  }
}
